import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// This app has never called serviceWorker.register() -- there is no
// current source path that registers one. A service worker persists
// across deploys until explicitly unregistered, so a browser that picked
// one up from an older build (a stale CRA "registerServiceWorker"
// residue, or any prior experiment) keeps intercepting fetches and can
// serve a stale bundle/index.html forever, invisibly, after every future
// deploy. Unregister unconditionally on every load so no returning
// browser can be stuck on one; a no-op when none is registered (the
// expected case). See RuntimeFingerprintCard's cache-audit section for
// the visible confirmation.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
        // eslint-disable-next-line no-console
        console.warn(
          "Unregistered a stale service worker:", registration.scope,
        );
      });
    })
    .catch(() => {});
}
